<template>
    <v-row v-if="!$store.getters.progress" class="ma-0 pb-offset">
        <v-col class="pa-0">
            <v-tabs
                app
                show-arrows
                :height="32"
				class="tabs-route"
                background-color="transparent"
                slider-color="primary">
                <v-tab exact-path ripple :to="{ path: '/orders/saleorders/' + id + '/'}" key="saleorders" >{{$trans('saleorder')}}</v-tab>
                <v-tab exact-path ripple :to="{ path: '/orders/saleorders/' + id + '/ddts' }" key="ddts" v-if="$store.getters.checkModelPermissions('ddt')">{{$trans('ddt')}}</v-tab>
                <v-tab exact-path ripple :to="{ path: '/orders/saleorders/' + id + '/purchaseorders' }" key="purchaseorders" v-if="$store.getters.checkModelPermissions('purchaseorder')">{{$trans('purchaseorder')}}</v-tab>
            </v-tabs>

            <v-slide-y-reverse-transition>
                <router-view v-show="!$store.getters.progress" :key="$route.fullPath" :default-input="defaultInput" :entity-title="entityTitle"></router-view>
            </v-slide-y-reverse-transition>

        </v-col>
    </v-row>
</template>

<script>
    import breadcrumbEntityMixin from '@/mixins/breadcrumbEntityMixin'

    export default {
        mixins: [breadcrumbEntityMixin],
        name: 'saleorder-tabs',
        props: {
            id: Number,
        },

        data() {
            return {
                models: {},
                defaultInput: {}
            }
        },

        computed: {
            entityTitle()  {
                return this.models.saleorder ? ['sectional', 'number'].reduce((acc, key) => this.models.saleorder[key] ? acc.concat(this.models.saleorder[key]) : acc, []).join(' / ') : ''
            }
        },

        created() {
            this.$store.commit('endProgress')
            this.axios.get('saleorders/' + this.id).then(response => {
                // get body data
                this.models = response.data.models
                this.defaultInput = {'company_id': this.models.business.id, 'saleorder_id': this.id}

            }, response => {
                // error callback
            })
        },

    }
</script>